import { ValueRegistryItem } from '../ValueRegistryItem';
import { ValueRegistryCategory } from '../ValueRegistryCategory';
export class ValueRegistryMedia extends ValueRegistryCategory {
    label = 'Media';
    constructor(parent) {
        super(parent);
        super.init();
    }
    backgroundImageFromImageActor = () => new ValueRegistryItem({
        value: ({ aspect }) => aspect.activeOf.image && aspect.activeOf.image.localImg,
    });
}
